import { RouteRecordRaw } from "vue-router";
import { UserStore } from "@/stores/user";

export const myTaskRouter: RouteRecordRaw[] = [
    {
        path: "/myTask",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/myTask/index",
        name: "MyTask",
        meta: {
            title: "待办工作",
            icon: "icon-daibangongzuo",
            auth: ({ userStore }: { userStore: UserStore }) => {
                // 待办工作根据企业身份展示，必须拥有采购客户或者仓储客户身份才展示待办
                return !!userStore.userInfo.proxyAccount?.roles?.length;
            }
        },
        children: [
            {
                path: "index",
                name: "MyTaskIndex",
                component: () => import("@/views/pages/myTask/index.vue"),
                meta: {
                    title: "待办工作",
                    hidden: true,
                    activeMenu: "MyTask",
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default myTaskRouter;
